<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="submit">
          <fg-input label="Name" type="text" v-model="user.name"
            :error="valErrors['name'] ? valErrors['name'][0] : null" />
          <fg-input label="Email" type="email" v-model="user.email"
            :error="valErrors['email'] ? valErrors['email'][0] : null" />
          <fg-input label="Telefonnummer" type="text" v-model="user.phone"
            :error="valErrors['phone'] ? valErrors['phone'][0] : null" />
          <template v-if="warehouses.length > 1">
            <div>
              <label>Standardlager</label>
              <div class="form-group has-label">
                <multiselect v-model="user.warehouse" :options="warehouses" track-by="id" label="short_name"
                  placeholder="Lager auswählen" />
              </div>
            </div>
          </template>
          <div>
            <label>Rolle</label>
            <div class="form-group has-label">
              <multiselect v-model="user.role" :options="roles" :allow-empty="false" deselect-label="" />
            </div>
          </div>
          <div>
            <label>Standort</label>
            <div class="form-group has-label" v-if="user.role === 'lageradmin' || user.role === 'user'">
              <multiselect @select="onSelectLocation" v-model="selectedLocations" :options="locations"
                :key="locations.id" label="name" :multiple="true" :preserve-search="true" track-by="name" />
            </div>
          </div>
          <div class="form-group has-label"
            v-if="(user.role === 'lageradmin' || user.role === 'user') && selectedLocations">
            <label>Zugriff zu dem Lager</label>
            <multiselect v-model="selectedWarehouses" :options="filteredWarehouses" :key="filteredWarehouses.id"
              :multiple="true" label="short_name" :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" track-by="short_name" />
          </div>
          <div class="form-group has-label"
            v-if="(user.role === 'lageradmin' || user.role === 'user') && selectedLocations">
            <label>Kostenstellen</label>
            <multiselect v-model="selectedCostCenters" :options="cost_centers" :key="cost_centers.id" :multiple="true"
              label="name" :close-on-select="false" :clear-on-select="false" :preserve-search="true" track-by="name" />
          </div>
          <button type="submit" class="btn btn-fill btn-info">Hinzufügen</button>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      roles: ['user', 'lageradmin', 'admin'],
      user: {
        email: '',
        name: '',
        role: 'user',
        location_ids: null,
        warehouse_ids: null,
        warehouse_id: '',
        cost_center_ids: null
      },
      valErrors: [],
      warehouses: [],
      locations: [],
      filteredWarehouses: [],
      selectedWarehouses: '',
      selectedLocations: '',
      cost_centers: [],
      selectedCostCenters: ''
    }
  },
  methods: {
    async submit() {
      await this.initCsrf()
      if (this.selectedWarehouses.length) {
        this.user.warehouse_ids = this.selectedWarehouses.map((warehouse) => warehouse.id)
      } else {
        this.user.warehouse_ids = null;
      }
      if (this.selectedLocations.length) {
        this.user.location_ids = this.selectedLocations.map((location) => location.id)
      } else {
        this.user.location_ids = null;
      }
      if (this.selectedCostCenters.length) {
        this.user.cost_center_ids = this.selectedCostCenters.map((location) => location.id)
      } else {
        this.user.cost_center_ids = null;
      }
      this.valErrors = []
      this.user.warehouse_id = this.user.warehouse ? this.user.warehouse.id : null
      this.$http.post('users', this.user).then(({ data }) => {
        this.$notify({
          message: 'Einladung zur Accountaktivierung wurde versandt.',
          type: 'success'
        })
        this.$router.push('/users')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    onSelectLocation() {
      this.filteredWarehouses = this.warehouses.filter(warehouse => {
        return this.selectedLocations.some(location => location.id === warehouse.location_id);
      });
    },

  },
  created() {
    this.$http.get(`/warehouses`).then(({ data }) => {
      this.warehouses = data
    })
    this.$http.get(`/locations`).then(({ data }) => {
      this.locations = data
    })
    this.$http.get(`/cost_centers`).then(({ data }) => {
      this.cost_centers = data
    })
  }
}
</script>

<style></style>
